<template>
  <b-modal :id="'modalTalk'+id" centered hide-backdrop hide-footer>
    <template v-slot:modal-header-close>
      <i class="fa fa-close"></i>
    </template>


    <div class="talk-content">

      <h5>Palestra</h5>
      <p class="talk-title">{{modalTalk.title}}</p>

    </div>

    <div class="list-speakers d-block">
      <div class="card card-palestrante" v-for="speaker in modalTalk.speakers" :key="speaker.id">
        <div class="row">
            <div class="col-2 text-center">
                <div class="foto-container"><img v-bind:src="speaker.photo" class="img-fluid foto-palestrante"></div>
            </div>
            <div class="col-10">
                <h3 class="palestrante-nome">{{speaker.name}}</h3>
                <p class="palestrante-cargo mb-0">{{speaker.job_title}}</p>
                <p class="palestrante-empresa mb-0">{{speaker.company}}</p>
            </div>
        </div>
      </div>
    </div>
    <div class="talk-details">
      <div class="talk-track">
          <span class="talk-palco">Local: <span v-html="modalTalk.track"></span></span>
      </div>
      <div class="talk-more-info d-flex align-items-center">
        <p class="talk-hora flex-fill"><i class="fas fa-clock"></i> <span class="talk-hora">{{modalTalk.date_start | hourOfDate}} <span v-if="modalTalk.date_end">às</span> {{modalTalk.date_end | hourOfDate}}</span></p>

        <p class="add-to"><a href="#" @click="addUserTalk(modalTalk)" title="Adicionar evento na sua agenda" v-b-tooltip.hover v-if="!isRestricted"><i class="far fa-calendar"></i> <span>Adicionar à sua agenda</span></a></p>
      </div>
    </div>
    
  </b-modal>
</template>
<script>
  export default {
	data() {
		return {
      id: 0,
			modalTalk: {},
      isRestricted: process.env.VUE_APP_RESTRICT_VIEW=="false"?false:true,
		}
	},
  mounted: function() {
    this.id = this._uid;
  },
    methods: {
      openTalk(talk) {
        this.modalTalk = talk;
        this.$bvModal.show('modalTalk'+this.id);
      },
      addUserTalk(talk) {
        talk.speakers.forEach(speaker => {
          speaker.talk = null;
        })
        this.$addUserTalk(talk);
      }
    },
    filters: {
      dayOfDate: function (value) {
        if (!value) return '';
        var theDate = new Date(value);
        return theDate.getDate();
      },
      hourOfDate: function (value) {
        if (!value) return '';
        var theDate = new Date(value);
        return ('0'+theDate.getHours()).slice(-2)+":"+('0'+theDate.getMinutes()).slice(-2);
      },
    },

  }
</script>
<style lang="scss">
#modalTalk {
  -webkit-transition: all .01s linear;
  -o-transition: all .01s linear;
  transition: all .01s linear;
}
.modal-dialog {

  .modal-content {
    background: white;
    border: solid 2px black;
    border-radius: 10px;
    .modal-header {
      padding: 0;
      border: 0;
      button.close {
        border-radius: 100%;
        border: 0;
        outline: 0;
        color: #05132E;
        width: 20px;
        height: 20px;
        font-size: 12px;
        margin: 10px 10px 0;
      }
    }
    .modal-body {
      .talk-content {
        h5 {
          font-size: 1rem;
          font-weight: 700;
          color: #868686;
        }
        p.talk-title {
          font-size: 1rem;
          font-weight: 700;
          color: black;
          margin-bottom: 1rem;
        }
      }

      .talk-details {
        .talk-track {
          text-align: center;
          padding: .5rem 0;
          span.talk-palco {
            padding: 10px 20px;
            background: #FFB600;
            font-weight: 700;
            border-radius: 8px;
            display: inline-block;
          }
        }
        .talk-more-info {
          border-width: 1px 0 1px 0;
          border-color: #DBDBDB;
          border-style: solid;
          padding: .5rem 0;
          margin: 1rem 0;
          p {
            margin: 0;
          }
          i {
            color: #868686;
          }
          a {
            color: black;
            text-decoration: none;
            span {
              font-size: .8rem;
              font-weight: 700;
            }
          }
        }
      }

    }
    div.list-speakers {
    }
    div.card-palestrante {
      background-color: transparent;
      margin-bottom: 15px;
      border: 0;
      a {
        text-decoration: none;
        color: white;
      }
      div.foto-container{
        padding-bottom:100%;
        overflow:hidden;
        position:relative;
        border-radius: 100%;
        img {
          position: absolute;
          left: 0;
        }
      }
      h3.palestrante-nome {
        font-size: 17px;
        line-height: 20px;
      }
      p.palestrante-cargo {
        font-size: 14px;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p.palestrante-empresa {
        font-size: 14px;
      }

    }

  }
}
</style>
